<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{ $t("lbl.pelletizing.qualityResult.selfTestPelletizingPelList") }}</h2>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/prd/selfTestPelletizing">
              <span>{{$t('tlt.pelletizing.selfTestPelletizing')}}</span>
            </router-link>
          </li>
          <li class="breadcrumb-item">
             <router-link :to="{path:'/prd/selfTestPelletizingPel', query:{id: selfTestId}}">
              <span>{{$t('tlt.pelletizing.selfTestPelletizingPel')}}</span>
            </router-link>
          </li>
        </ul>
      </div>
      <!-- <div class="col-lg-2">
                <div class="float-lg-right">
                    <button class="btn btn-outline-primary" v-on:click="MMFNew('selfTestPelletizingPel')">
                        <i class="fa fa-fw fa-lg fa-plus"></i>
                        <span class="text">{{ $t("btn.basic.add") }}</span>
                    </button>
                </div>
      </div>-->
    </div>
    <section class="app-content">
      <!-- <div id="accordionFilter" class="content">
        <div class="card">
          <div
            id="collapseOne"
            class="collapse show"
            aria-labelledby="headingOne"
            data-parent="#accordionFilter"
          >
            <div class="card-body">
              <form class="row">
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t("lbl.selfTestPelletizingPel.shiftPlanNum")}}</label>
                  <input class="form-control" type="text" v-model="selfTestCodeFilter">
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t("lbl.selfTestPelletizingPel.analysisTime")}}</label>
                  <MmfDatepicker  v-model="analysisTimeDateFilter"></MmfDatepicker>
                </div>
                  <div class="form-group col-md-2">
                  <label class="control-label">{{$t("lbl.selfTestPelletizingPel.checkUser")}}</label>
                  <input class="form-control" type="text" v-model="checkUserFilter">
                </div>
                
               

                  <div class="col-lg-12 align-self-end">
                  <div class="float-lg-right">
                     <button class="btn btn-outline-secondary mr-1" type="button"
                                         v-on:click="MMFClearFilter('selfTestPelletizingPel')">
                          <i class="fa fa-fw fa-lg fa-eraser"></i>
                          <span class="text">{{ $t("btn.basic.clear") }}</span>
                      </button>
                    <button
                      class="btn btn-primary"
                      type="button"
                      v-on:click="MMFLoadRows('selfTestPelletizingPel')"
                    >
                      <i class="fa fa-fw fa-lg fa-search"></i>
                      <span class="text">{{ $t("btn.basic.search") }}</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>-->

      <div id="selfTestPelletizingPelTable" class="content">
        <div class="card my-1">
          <div
            id="collapseTwo"
            class="collapse show"
            aria-labelledby="headingTwo"
            data-parent="#accordionResult"
          >
            <div class="card-body">
              <div class="bs-component"></div>
              <mmf-table
                entity="selfTestPelletizingPel"
                inline-actions-disabled
                :singleChoice="true"
                disableDelete
              ></mmf-table>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
import { filterFields } from "@/model/prd/qualityMgt/selfTest/SelfTestPelletizingPel";
import { gridFields } from "@/model/prd/qualityMgt/selfTest/SelfTestPelletizingPel";
import MmfTable from "@/components/MmfTable";
import MmfDatepicker from "@/components/MmfDatepicker";

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
  getterType: "selfTestPelletizingPel/getField",
  mutationType: "selfTestPelletizingPel/updateField"
});

export default {
  name: "selfTestPelletizingPelList",
  data() {
    return {};
  },
  components: { MmfTable, MmfDatepicker },
  computed: {
    // generate and add getters and setters using the filter names defined in
    // entity model

    ...mapFields(filterFields),

    ...mapState("selfTestPelletizingPel",{
      rows: state => state.rows,
      tableColumns: gridFields,
      entity: state => state.entity,
       baseModuleUrl: state => state.baseModuleUrl,
      selfTestId: state => state.selfTestId
    })
  },
  methods: {
    ...mapActions("base", ["MMFLoadRows", "MMFClearFilter", "MMFNew"]),
      ...mapActions("selfTestPelletizingPel", ["Load"])
  },
  created() {
  this.Load(this.$route.query.id);
  }
};
</script>
